/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/embedding.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Generates dense vector embeddings from multimodal input using a specified inference endpoint with the `embedding` task type. Use this function to generate query vectors for KNN searches from multimodal inputs against your vectorized data or other dense vector based operations.',
  examples: [
    'FROM dense_vector_text METADATA _score\n| EVAL query_embedding = EMBEDDING("be excellent to each other", "test_embedding_inference")\n| WHERE KNN(text_embedding_field, query_embedding)\n| SORT _score DESC\n| LIMIT 10',
    'ROW b64_input="This is an image"\n| EVAL embedding = EMBEDDING("data:image/jpeg;base64,VGhpcyBpcyBhbiBpbWFnZQ==", "test_embedding_inference", {"type": "image"})',
  ],
  params: {
    value: 'Value to generate embeddings from. Must be a non-null literal string value. Use data type and format options to specify the content type and format (e.g. plain text, base64-encoded images) of the input.',
    inference_id: 'Identifier of an existing inference endpoint that will generate the embeddings. The inference endpoint must have the `embedding` task type and should use the same model that was used to embed your indexed data.',
    options: '(Optional) Options for the input value.',
  },
};

export default docs;
